(function () {
    var aiSection = document.querySelector('.ai-section');
    var aiAutoplayDelay = 7000;

    function resetAiCard(card) {
        (card.aiTimers || []).forEach(function (timer) {
            clearTimeout(timer);
            clearInterval(timer);
        });
        card.aiTimers = [];

        var typedEl = card.querySelector('.ai-chat-typed');

        if (typedEl) {
            typedEl.textContent = '';
        }

        card.classList.add('is-anim');
        card.querySelectorAll('.ai-msg, .ai-report-reveal').forEach(function (el) {
            el.classList.remove('is-visible');
        });
    }

    function playAiCard(card) {
        resetAiCard(card);

        var typedEl = card.querySelector('.ai-chat-typed');
        var messages = card.querySelectorAll('.ai-msg');

        function later(fn, ms) {
            card.aiTimers.push(setTimeout(fn, ms));
        }

        var elapsed = 800;
        var typeSpeed = 35;

        messages.forEach(function (message) {
            if (message.classList.contains('ai-msg-user')) {
                var text = message.querySelector('p').textContent;
                var startAt = elapsed;

                later(function () {
                    var i = 0;
                    var timer = setInterval(function () {
                        i += 1;
                        typedEl.textContent = text.slice(0, i);

                        if (i >= text.length) {
                            clearInterval(timer);
                        }
                    }, typeSpeed);
                    card.aiTimers.push(timer);
                }, startAt);

                elapsed += text.length * typeSpeed + 450;

                later(function () {
                    typedEl.textContent = '';
                    message.classList.add('is-visible');
                }, elapsed);

                elapsed += 900;
            } else {
                later(function () {
                    message.classList.add('is-visible');
                }, elapsed);

                elapsed += 900;
            }
        });

        var reveals = card.querySelectorAll('.ai-report-reveal');
        var revealAt = 700;

        reveals.forEach(function (el) {
            var startAt = revealAt;

            later(function () {
                el.classList.add('is-visible');
            }, startAt);

            revealAt += el.classList.contains('ai-report-heading') ? 350 : 280;
        });
    }

    if (aiSection) {
        initAiSection();
    }

    function initAiSection() {
        var stage = aiSection.querySelector('.ai-stage');
        var nodes = aiSection.querySelectorAll('.ai-node');
        var panels = aiSection.querySelectorAll('.ai-panel');
        var infos = aiSection.querySelectorAll('.ai-info-item');
        var timer = aiSection.querySelector('.ai-timer');
        var linksSvg = aiSection.querySelector('.ai-links');
        var canvas = aiSection.querySelector('.ai-canvas');
        var ctx = canvas.getContext('2d');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var desktopQuery = window.matchMedia('(min-width: 992px)');
        var svgNs = 'http://www.w3.org/2000/svg';
        var current = 0;
        var visible = false;
        var nextTimeout = null;
        var routes = [];
        var rafId = null;
        var lastFrame = 0;
        var accent = '#4d9fff';
        var minis = [];
        var links = [];

        aiSection.style.setProperty('--ai-delay', aiAutoplayDelay + 'ms');

        function layoutStage() {
            minis.forEach(function (mini) {
                mini.parentNode.removeChild(mini);
            });
            minis = [];
            links = [];
            linksSvg.innerHTML = '';

            if (!desktopQuery.matches) {
                nodes.forEach(function (node) {
                    node.style.left = '';
                    node.style.top = '';
                    node.classList.remove('is-left');
                });
                return;
            }

            var width = stage.clientWidth;
            var height = stage.clientHeight;
            var cx = width / 2;
            var cy = height / 2;
            var radius = Math.min(width, height) / 2 - 36;
            var count = nodes.length;
            var nodeAngles = [];

            stage.style.setProperty('--ai-r', radius + 'px');
            linksSvg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);

            nodes.forEach(function (node, index) {
                var angle = -90 + (360 / count) * index;
                var rad = angle * Math.PI / 180;
                var x = cx + radius * Math.cos(rad);
                var y = cy + radius * Math.sin(rad);

                nodeAngles.push(angle);
                node.style.left = x + 'px';
                node.style.top = y + 'px';
                node.classList.toggle('is-left', x < cx - 4);

                var line = document.createElementNS(svgNs, 'line');
                line.setAttribute('class', 'ai-link ' + (node.className.match(/ai-theme-\w+/) || [''])[0]);
                line.setAttribute('x1', cx);
                line.setAttribute('y1', cy);
                line.setAttribute('x2', x);
                line.setAttribute('y2', y);
                linksSvg.appendChild(line);
                links.push(line);
            });

            var miniCount = 14;

            for (var k = 0; k < miniCount; k++) {
                var miniAngle = (360 / miniCount) * k + 7;
                var tooClose = nodeAngles.some(function (a) {
                    var diff = Math.abs(((miniAngle - a) % 360 + 540) % 360 - 180);
                    return diff < 12;
                });

                if (tooClose) {
                    continue;
                }

                var miniRad = miniAngle * Math.PI / 180;
                var miniRadius = radius + (k % 3 === 0 ? 30 : 0);
                var mini = document.createElement('span');
                mini.className = 'ai-mini';
                mini.style.left = cx + miniRadius * Math.cos(miniRad) + 'px';
                mini.style.top = cy + miniRadius * Math.sin(miniRad) + 'px';
                mini.style.animationDelay = (k * 0.35) + 's';
                stage.appendChild(mini);
                minis.push(mini);
            }

            syncActive();
        }

        function syncActive() {
            nodes.forEach(function (node, index) {
                var isActive = index === current;
                node.classList.toggle('is-active', isActive);
                node.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            panels.forEach(function (panel, index) {
                panel.classList.toggle('is-active', index === current);
            });

            infos.forEach(function (info, index) {
                info.classList.toggle('is-active', index === current);
            });

            links.forEach(function (link, index) {
                link.classList.toggle('is-active', index === current);
            });

            var activePanel = panels[current];
            accent = getComputedStyle(activePanel).getPropertyValue('--ai-accent').trim() || accent;
            aiSection.style.setProperty('--ai-active', accent);
        }

        function restartTimer() {
            timer.classList.remove('is-running', 'is-paused');
            void timer.offsetWidth;
            timer.classList.add('is-running');
        }

        function scheduleNext() {
            clearTimeout(nextTimeout);

            if (!visible || nodes.length < 2) {
                return;
            }

            restartTimer();
            nextTimeout = setTimeout(function () {
                activate((current + 1) % nodes.length);
            }, aiAutoplayDelay);
        }

        function activate(index) {
            current = index;
            syncActive();

            if (visible) {
                playAiCard(panels[current]);
                scheduleNext();
            }
        }

        nodes.forEach(function (node, index) {
            node.addEventListener('click', function () {
                if (index !== current) {
                    activate(index);
                }
            });

            node.addEventListener('mouseenter', function () {
                if (index !== current) {
                    activate(index);
                }
            });
        });

        stage.addEventListener('mouseenter', function () {
            clearTimeout(nextTimeout);
            timer.classList.add('is-paused');
        });

        stage.addEventListener('mouseleave', function () {
            timer.classList.remove('is-paused');
            scheduleNext();
        });

        var routeDefs = [
            [0.03, 0.8, 0.48, 0.16],
            [0.3, 0.94, 0.97, 0.4],
            [0.58, 0.06, 0.97, 0.8]
        ];

        function routePoint(route, t) {
            var u = 1 - t;

            return {
                x: u * u * route.x1 + 2 * u * t * route.cx + t * t * route.x2,
                y: u * u * route.y1 + 2 * u * t * route.cy + t * t * route.y2
            };
        }

        function canvasEnabled() {
            return desktopQuery.matches;
        }

        function resizeCanvas() {
            if (!canvasEnabled()) {
                canvas.width = 0;
                canvas.height = 0;
                routes = [];
                return;
            }

            var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
            var width = aiSection.clientWidth;
            var height = aiSection.clientHeight;

            canvas.width = width * dpr;
            canvas.height = height * dpr;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

            routes = routeDefs.map(function (def, index) {
                var x1 = def[0] * width;
                var y1 = def[1] * height;
                var x2 = def[2] * width;
                var y2 = def[3] * height;
                var dist = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));

                return {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    cx: (x1 + x2) / 2,
                    cy: (y1 + y2) / 2 - dist * 0.3,
                    t: (index * 0.137) % 1,
                    speed: 0.04 + index * 0.008,
                    tinted: index !== 1
                };
            });
        }

        function drawPlane(x, y, angle, color) {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(angle);
            ctx.fillStyle = color;
            ctx.shadowColor = color;
            ctx.shadowBlur = 12;
            ctx.beginPath();
            ctx.moveTo(9, 0);
            ctx.lineTo(-5, -5);
            ctx.lineTo(-2, 0);
            ctx.lineTo(-5, 5);
            ctx.closePath();
            ctx.fill();
            ctx.restore();
        }

        function drawRoutes(dt) {
            if (!canvasEnabled()) {
                return;
            }

            var width = aiSection.clientWidth;
            var height = aiSection.clientHeight;

            ctx.clearRect(0, 0, width, height);

            routes.forEach(function (route) {
                var color = route.tinted ? accent : '#ffffff';

                ctx.setLineDash([4, 7]);
                ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.moveTo(route.x1, route.y1);
                ctx.quadraticCurveTo(route.cx, route.cy, route.x2, route.y2);
                ctx.stroke();
                ctx.setLineDash([]);

                [[route.x1, route.y1], [route.x2, route.y2]].forEach(function (pt) {
                    ctx.fillStyle = 'rgba(255, 255, 255, 0.55)';
                    ctx.beginPath();
                    ctx.arc(pt[0], pt[1], 2, 0, Math.PI * 2);
                    ctx.fill();
                });

                if (!reduceMotion) {
                    route.t += route.speed * dt;

                    if (route.t > 1) {
                        route.t -= 1;
                    }
                }

                var trailLength = 0.12;
                var steps = 10;

                for (var i = 0; i < steps; i++) {
                    var t0 = route.t - trailLength * (i / steps);
                    var t1 = route.t - trailLength * ((i + 1) / steps);

                    if (t1 < 0) {
                        break;
                    }

                    var p0 = routePoint(route, t0);
                    var p1 = routePoint(route, t1);

                    ctx.strokeStyle = color;
                    ctx.globalAlpha = 0.85 * (1 - i / steps);
                    ctx.lineWidth = 2;
                    ctx.beginPath();
                    ctx.moveTo(p0.x, p0.y);
                    ctx.lineTo(p1.x, p1.y);
                    ctx.stroke();
                }

                ctx.globalAlpha = 1;

                var pos = routePoint(route, route.t);
                var ahead = routePoint(route, Math.min(route.t + 0.01, 1));
                drawPlane(pos.x, pos.y, Math.atan2(ahead.y - pos.y, ahead.x - pos.x), color);
            });
        }

        function loop(timestamp) {
            var dt = lastFrame ? Math.min((timestamp - lastFrame) / 1000, 0.05) : 0;
            lastFrame = timestamp;

            drawRoutes(dt);

            if (visible && canvasEnabled() && !reduceMotion) {
                rafId = requestAnimationFrame(loop);
            }
        }

        var resizeFrame = null;

        window.addEventListener('resize', function () {
            cancelAnimationFrame(resizeFrame);
            resizeFrame = requestAnimationFrame(function () {
                resizeCanvas();
                layoutStage();

                cancelAnimationFrame(rafId);

                if (visible && canvasEnabled() && !reduceMotion) {
                    lastFrame = 0;
                    rafId = requestAnimationFrame(loop);
                } else {
                    drawRoutes(0);
                }
            });
        });

        resizeCanvas();
        layoutStage();
        drawRoutes(0);

        function setVisible(isIn) {
            if (isIn === visible) {
                return;
            }

            visible = isIn;
            aiSection.classList.toggle('is-offscreen', !visible);

            if (visible) {
                playAiCard(panels[current]);
                scheduleNext();
                cancelAnimationFrame(rafId);
                lastFrame = 0;

                if (canvasEnabled() && !reduceMotion) {
                    rafId = requestAnimationFrame(loop);
                }
            } else {
                clearTimeout(nextTimeout);
                timer.classList.remove('is-running', 'is-paused');
                cancelAnimationFrame(rafId);
            }
        }

        aiSection.classList.add('is-offscreen');

        if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
                setVisible(entries[0].isIntersecting);
            }, { threshold: 0.25 }).observe(aiSection);
        } else {
            setVisible(true);
        }
    }
})();
